module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-6"
  }, [_c('user-card')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6"
  }, [_c('edit-profile-form')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e3e85174!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/UserProfile.vue
// module id = 454
// module chunks = 1